import { ViewModel, View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { Enum, IEnumTranslator, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { IUnit } from "../../units/iUnit";
import { IProduct } from "../iProduct";
import { ProductEditorViewModel, ProductInserter, ProductUpdater } from "../productEditor/productEditor-viewModel";
import { ProductManipulationView } from "./productManipulation-view"
import { downloadFile } from "src/uicomponents/components/utilities";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { FileChooser } from "src/common/utilities";
import { Popup } from "leaflet";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ProductGroupSelectorViewModel } from "../../productGroup/productGroupSelector/productGroupSelector-viewModel";
import { ProductTypeSelectorViewModel } from "../productTypeSelector";
import { UnitMultiSelectorViewModel } from "../../units/unitMultiSelector";
import { TranslatorConverter } from "src/TranslatorConverter";

export class ProductManipulationViewModel extends WindowViewModel {
    public getTitle(): string {
        return translate("productManipulation-viewModel.productDefinition", {});
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.products = ObservableArray.create<product>();
        this.productTypeEnumProvider = new ProductTypeEnumProvider();
        this.loader = new ServerSideDataLoader(filteringInformation => this.refreshPaged(filteringInformation), 30);
        this.refresh()
    }
    GetDefaultView(): View<ViewModel> {
        return new ProductManipulationView();
    }
    public getTypeId(): string {
        return "VM-3D1691A9-DB79-4F48-B6B9-706239E4D472"
    }

    public set products(v: ObservableArray<product>) { this._products = v; } public get products(): ObservableArray<product> { return this._products; } private _products: ObservableArray<product>;
    public set productTypeEnumProvider(v: ProductTypeEnumProvider) { this._productTypeEnumProvider = v; } public get productTypeEnumProvider(): ProductTypeEnumProvider { return this._productTypeEnumProvider; } private _productTypeEnumProvider: ProductTypeEnumProvider;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader; } private _loader: ServerSideDataLoader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;

    async refresh() {
        await this.loader.refresh();
    }
    async refreshPaged(filteringInformation: any): Promise<PaginationInfo> {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/SimpleProductManipulationServices/GetAllSimpleProducts', {
                FurtherQueryInfo: filteringInformation
            });
            this.products.update(...result.Products.map(q => {
                let r = new product(this);
                r.id = q.Id;
                r.name = q.Name;
                r.code = q.Code;
                r.secondaryCode = q.SecondaryCode;
                r.groupId = q.GroupId;
                r.groupName = q.GroupName;
                r.unitIds = q.MeasuredProducts.map(x => x.UnitId);
                r.typeId = q.ProductTypeId;
                r.imageUrl = q.ImageUrl;
                r.hasImage = stringIsNullOrEmpty(q.ImageUrl) == false;
                r.length = q.Length;
                r.width = q.Width;
                r.height = q.Height;
                r.weight = q.Weight;
                r.secondWeight = q.SecondWeight;
                r.technicalNumber = q.TechnicalNumber;
                r.isSafetyMaterial = q.IsSafetyMaterial;
                r.canEdit = false;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage, result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0, 0);
        } finally {
            this.isLoading = false;
        }
    }
    async addNew() {
        let popup = new ProductEditorViewModel(this, new ProductInserter());
        let result = await this.showPopup(popup);
        if (result != null) {
            this.refresh();
        }
    }

    async edit(product: product) {
        let popup = new ProductEditorViewModel(this, new ProductUpdater());
        product.cloneTo(popup);
        let result = await this.showPopup(popup);
        if (result != null) {
            this.refresh();
        }
    }

    async uploadProductsFromExcelFile() {
        let popup = new ProductUploaderViewModel(this);
        let result = await this.showPopup(popup);
        if (result == true) {
            this.refresh();
        }
    }
}

export class product extends ViewModel implements IProduct {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProductManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.unitIds = [];
    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set code(v: string) { this._code = v; } public get code(): string { return this._code; } private _code: string;
    public set secondaryCode(v: string) { this._secondaryCode = v; } public get secondaryCode(): string { return this._secondaryCode; } private _secondaryCode: string;
    public set unitIds(v: string[]) { this._unitIds = v; } public get unitIds(): string[] { return this._unitIds; } private _unitIds: string[];
    public set groupId(v: string) { this._groupId = v; } public get groupId(): string { return this._groupId; } private _groupId: string;
    public set groupName(v: string) { this._groupName = v; } public get groupName(): string { return this._groupName; } private _groupName: string;
    public set typeId(v: string) { this._typeId = v; } public get typeId(): string { return this._typeId; } private _typeId: string;
    public set imageUrl(v: string) { this._imageUrl = v; } public get imageUrl(): string { return this._imageUrl; } private _imageUrl: string;
    public set hasImage(v: boolean) { this._hasImage = v; } public get hasImage(): boolean { return this._hasImage; } private _hasImage: boolean;
    public set length(v: number) { this._length = v; } public get length(): number { return this._length; } private _length: number;
    public set width(v: number) { this._width = v; } public get width(): number { return this._width; } private _width: number;
    public set height(v: number) { this._height = v; } public get height(): number { return this._height; } private _height: number;
    public set weight(v: number) { this._weight = v; } public get weight(): number { return this._weight; } private _weight: number;
    public set secondWeight(v: number) { this._secondWeight = v; } public get secondWeight(): number { return this._secondWeight; } private _secondWeight: number;
    public set technicalNumber(v: string) { this._technicalNumber = v; } public get technicalNumber(): string { return this._technicalNumber; } private _technicalNumber: string;
    public set isSafetyMaterial(v: boolean) { this._isSafetyMaterial = v; } public get isSafetyMaterial(): boolean { return this._isSafetyMaterial; } private _isSafetyMaterial: boolean;
    public set canEdit(v: boolean) { this._canEdit = v; } public get canEdit(): boolean { return this._canEdit; } private _canEdit: boolean;

    private _typedParent: ProductManipulationViewModel;

    setProductGroupId(id: string) {
        this.groupId = id;
    }
    getProductGroupId(): string {
        return this.groupId;
    }

    setProductTypeId(id: string) {
        this.typeId = id;
    }
    getProductTypeId(): string {
        throw this.typeId;
    }

    cloneTo(product: IProduct) {
        product.id = this.id;
        product.name = this.name;
        product.code = this.code;
        product.secondaryCode = this.secondaryCode;
        product.imageUrl = this.imageUrl;
        product.hasImage = this.hasImage;
        product.length = this.length;
        product.width = this.width;
        product.height = this.height;
        product.weight = this.weight;
        product.secondWeight = this.secondWeight;
        product.technicalNumber = this.technicalNumber;
        product.isSafetyMaterial = this.isSafetyMaterial;
        product.canEdit = this.canEdit;
        product.setUnitIds(this.getUnitIds());
        product.setProductGroupId(this.groupId);
        product.setProductTypeId(this.typeId);
    }
    edit() {
        this._typedParent.edit(this);
    }

    setUnitIds(value: string[]) {
        this.unitIds = value;
    }
    getUnitIds(): string[] {
        return this.unitIds;
    }

}

export class unit extends ViewModel {
    public getTypeId(): string { return ''; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ViewModel) {
        super(parent);

    }

    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
}

export class ProductUploaderViewModel extends ViewModel implements IPopup {
    public getTypeId(): string { return 'excel-selector'; }
    public GetDefaultView(): View<ViewModel> { return null; }
    constructor(parent: ProductManipulationViewModel) {
        super(parent);
        this._parent = parent;
        this.productGroupSelector = new ProductGroupSelectorViewModel(this);
        this.productTypeSelector = new ProductTypeSelectorViewModel(this);
        this.unitSelector = new UnitMultiSelectorViewModel(this);
        this.fileName = translate("productManipulation-viewModel.fileNotChoosed", {});
    }

    private _parent: ProductManipulationViewModel;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set fileContent(v: string) { this._fileContent = v; } public get fileContent(): string { return this._fileContent; } private _fileContent: string;
    public set unitSelector(v: UnitMultiSelectorViewModel) { this._unitSelector = v; } public get unitSelector(): UnitMultiSelectorViewModel { return this._unitSelector; } private _unitSelector: UnitMultiSelectorViewModel;
    public set productGroupSelector(v: ProductGroupSelectorViewModel) { this._productGroupSelector = v; } public get productGroupSelector(): ProductGroupSelectorViewModel { return this._productGroupSelector; } private _productGroupSelector: ProductGroupSelectorViewModel;
    public set productTypeSelector(v: ProductTypeSelectorViewModel) { this._productTypeSelector = v; } public get productTypeSelector(): ProductTypeSelectorViewModel { return this._productTypeSelector; } private _productTypeSelector: ProductTypeSelectorViewModel;
    public set fileName(v: string) { this._fileName = v; } public get fileName(): string { return this._fileName; } private _fileName: string;

    closePopup(result: any) {
        return result;
    }

    async chooseFile() {
        let fileChooser = new FileChooser;
        let choosedFile = await fileChooser.chooseFile();
        if (choosedFile.isChoosed == true) {
            this.fileContent = choosedFile.fileContent;
            this.fileName = choosedFile.filename;
        }
    }

    async downloadExcelTemplateFile() {
        try {
            this.isLoading = true;
            let excelFile = await ServerConnection.callServer("/Complex/SimpleProductManipulationServices/DownloadExcelTemplateForProductImport", {});
            downloadFile(excelFile.ExcelFile, "Template.xlsx");
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    async uploadProducts() {
        try {
            let verificationResult = this.verify();
            if (verificationResult.length > 0) {
                this.messageBoxConfirmWarning(verificationResult.join('\n'), translate("productManipulation-viewModel.uploadProduct", {}));
                return;
            }

            this.isLoading = true;
            let serverResult = await ServerConnection.callServer("/Complex/SimpleProductManipulationServices/ImportProductFromExcelFile", {
                ExcelFile: this.fileContent,
                ProductGroupId: this.productGroupSelector.selectedGroup?.id,
                ProductTypeId: this.productTypeSelector.selectedItem?.id,
                ProductUnitIds: this.unitSelector.selectedItems.map(unit => unit.id)
            });

            if (serverResult.IsSuccessful == true && serverResult.IsValidFile == true) {
                await this.messageBoxConfirmSuccess(translate("productManipulation-viewModel.successfullyRegistered", {}), translate("productManipulation-viewModel.addProduct", {}));
                this.closePopup(true);
            } else if (serverResult.IsSuccessful == true && serverResult.IsValidFile == false) {
                downloadFile(serverResult.ExcelFile, "Products List.xlsx");
                await this.messageBoxConfirmWarning(translate("productManipulation-viewModel.fileRowsProblem", {}), translate("productManipulation-viewModel.error", {}));
            }
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.fileContent)) {
            result.push(translate("productManipulation-viewModel.pleaseChooseFile", {}));
        } if (this.productTypeSelector.selectedItem == null) {
            result.push(translate("productManipulation-viewModel.productTypeNotSeleted", {}));
        } if (this.unitSelector.selectedItems.length == 0) {
            result.push(translate("productEditor-viewModel.unitError", {}));
        } if(this.productGroupSelector.selectedGroup == null){
            result.push("لطفا گروه کالا را انتخاب کنید.");
        }

        return result;
    }

    async back() {
        this.closePopup(false);
    }

}

export class ProductTypeEnumProvider extends Enum implements IEnumTranslator {
    constructor() {
        super();
        this.values = [1, 2, 3, 4];
        this.translator = this;
        this.converter = new TranslatorConverter();
    }
    private converter: TranslatorConverter;
    GetString(value: any) {
        return this.converter.productTypeConvertor(value);
    }
}